import warning from "../assets/warning.svg";
import ContactUs from "./ContactUs";

const EmergencyMode = ({ message }) => {
  return (
    <div className="emergency-mode-container">
      <div className="emergency-mode-content">
        <div className="emergency-mode-icon">
          <img src={warning} alt="warningIcon" width="140" height="60" />
        </div>
        <div className="emergency-mode-text">
          <h1>We are fixing it!</h1>
          <p>
            {message ? (
              message
            ) : (
              <>
                One or more of your dashboards are down for maintenance. We are
                working to resolve this, so please check back soon.
              </>
            )}{" "}
            <ContactUs />
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmergencyMode;
